export const zIndexRegistry = {
    menu: 950,
};
